import React, { Component, useState } from 'react';
import { Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

class DropdownFlat extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedValue: this.props.selectedValue,
            key: props.keyObjName,
            value: props.valueObjName,
        }
    }
    render() {

        const handleSelect = (e) => {
            console.log(e);
            this.setState({
                selectedValue: e
            })
        }

        const key = this.props.keyObjName
        const value = this.props.valueObjName
        console.log("key", key, "value", value, "select",this.props.selectedValue)

        return (
            <Form.Control as="select" id={this.props.id} disabled={this.props.disabled} defaultValue={this.props.defaultValue} value={this.props.selectedValue} name={this.props.name} onChange={this.props.actions}>
                <option disabled value={''} key="empty">{this.props.defaultopt}</option>
                {this.props.data.map((item, index) => {
                    return (
                        <option key={index} value={item[`${key}`]}>{item[`${value}`]}</option>
                    )
                })}
            </Form.Control>
        );
    }
}

export default DropdownFlat;


